import React, { useEffect, useState } from "react";
import { IRevenueHistoryItem, IRevenueHistoryItemStudentList } from "../../../redux/reducers";
import InfiniteScroll from "react-infinite-scroll-component";
import { CircularProgress } from "@mui/material";
import "./styles.scss";
import RevenueHistoryItemRawStudentRaw
  from "./ExpertLessonHistoryItemRow/RevenueHistoryItemRawStudentRaw/RevenueHistoryItemRawStudentRaw";
import { utcDateAndTimeStringToLocalDate } from "../../../utils/dateFormat";

interface ExpertLessonHistoryPreviewProps {
  revenueItems: IRevenueHistoryItem[];
}

const ExpertRevenueHistoryPreview: React.FC<ExpertLessonHistoryPreviewProps> = (
  props
) => {
  const { revenueItems } = props;

  function generateRevenueItemStudentsRaws(
    revenueHistoryItemStudentList: IRevenueHistoryItemStudentList[]
  ) {
    return revenueHistoryItemStudentList?.map(
      (revenueHistoryItemStudent: IRevenueHistoryItemStudentList) => {
        return <RevenueHistoryItemRawStudentRaw
          key={revenueHistoryItemStudent.avatar}
          avatar={revenueHistoryItemStudent.avatar}
          userName={revenueHistoryItemStudent.userName}
          points={revenueHistoryItemStudent.points}
        />;
      });
  }

  const generateRow = (revenueItems: IRevenueHistoryItem[]) => {
    return revenueItems.map((revenueItem: IRevenueHistoryItem, index: number) => {
      return (
        <div className="summary-single">
          <div className="title-area">
            <span className="no">{index + 1}</span>
            {utcDateAndTimeStringToLocalDate(revenueItem.date)}
          </div>
          <small>( {revenueItem.lessonName} )</small>
          <ul>
            {generateRevenueItemStudentsRaws(revenueItem.revenueHistoryItemStudentList)}
          </ul>
        </div>
      );
    });
  };
  const pageSize: number = 20;
  const [count, setCount] = useState<{ prev: number; next: number }>({
    prev: 0,
    next: pageSize
  });
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [current, setCurrent] = useState<IRevenueHistoryItem[]>([]);
  const getMoreData = () => {
    if (current.length === revenueItems.length) {
      setHasMore(false);
      return;
    }
    setCurrent(
      current.concat(revenueItems.slice(count.prev + pageSize, count.next + pageSize))
    );
    setCount((prevState) => ({
      prev: prevState.prev + pageSize,
      next: prevState.next + pageSize
    }));
  };

  useEffect(() => {
    setCurrent(revenueItems.slice(count.prev, count.next));
  }, [revenueItems]);

  return (
    <div className="history_row">
      <InfiniteScroll
        next={getMoreData}
        hasMore={hasMore}
        scrollThreshold={0.4}
        loader={
          <div className="spinner_container">
            <CircularProgress color="success" className="spinner" size={20} />
          </div>
        }
        dataLength={current.length}
      >
        {generateRow(current)}
      </InfiniteScroll>
    </div>
  );
};

export default ExpertRevenueHistoryPreview;
